<template>
    <el-col :xs="{span:24}" :md="width" v-show="show">
        <el-form-item
            :class="className"
            :label="displayName" 
            :prop="name"
            :rules="rules">
            <textarea :name="fieldName" :value="data[name]" hidden="hidden"></textarea>
            <div v-if="disabled" v-html="data[name]"></div>
            <div v-else style="border: 1px solid #ccc">
                <Toolbar
                    style="border-bottom: 1px solid #ccc"
                    :editor="editorRef"
                    :defaultConfig="toolbarConfig"
                    :mode="mode"
                />
                <Editor style="height: 400px; overflow-y: hidden;"
                    v-model.lazy="data[name]"
                    :defaultConfig="editorConfig"
                    :mode="mode"
                    @onCreated="handleCreated"
                />
            </div>
        </el-form-item>
    </el-col>
</template>

<script>
    import '@wangeditor/editor/dist/css/style.css' // 引入 css
    import { onBeforeUnmount,  shallowRef } from 'vue'
    import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
    import qweBaseField from "../BaseField"

    export default {
        mixins:[qweBaseField],
        name:"HtmlField",
        components: { Editor, Toolbar },
        data:function(){
            return {
                valueHtml:""
            }
        },
        setup() {
            const editorRef = shallowRef();

            const toolbarConfig = {}
            const editorConfig = { placeholder: '请输入内容...' }

            // 组件销毁时，也及时销毁编辑器
            onBeforeUnmount(() => {
                const editor = editorRef.value
                if (editor == null) return
                editor.destroy()
            })

            const handleCreated = (editor) => {
                editorRef.value = editor // 记录 editor 实例，重要！
            }

            return {
                editorRef,
                mode: 'default', // 或 'simple'
                toolbarConfig,
                editorConfig,
                handleCreated
            };
        }
}

</script>